'use client'
import { PopupWrapper } from '@/components'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import { Box, Button, Typography } from '@mui/material'

interface SuccessModalProps {
  isOpen: boolean
  onConfirm: () => void
}

export const SuccessModal = ({ isOpen, onConfirm }: SuccessModalProps) => {
  return (
    <PopupWrapper isOpen={isOpen} handleClose={onConfirm} width="520px" hiddenIcon clickOutSite={false}>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        {/* Success Icon */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <CheckCircleOutlineRoundedIcon
            sx={{
              fontSize: {
                xs: '3rem',
                md: '4rem',
                lg: '4.5rem',
              },
            }}
          />
        </Box>

        {/* Message */}
        <Typography
          sx={{
            fontSize: {
              xs: '1.15rem',
              md: '1.5rem',
              lg: '2rem',
            },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Cảm ơn bạn
          <br />
          đã đánh giá sản phẩm!
        </Typography>
        <Typography
          sx={{
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Đánh giá của bạn sẽ cần 1 đến 2 ngày để xét duyệt và hiển thị trên website. Xu sẽ được cộng vào tài
          khoản của bạn. Sau đó bạn có thể sử dụng xu để đổi lấy <strong> tiền mặt</strong>.
        </Typography>

        {/* Confirm Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={onConfirm}
          size="large"
          sx={{
            borderRadius: '999px',
            textTransform: 'none',
          }}
        >
          Xác nhận
        </Button>
      </Box>
    </PopupWrapper>
  )
}
